import React, { useState } from 'react';
import { string, bool, func } from 'prop-types';
import { compose } from 'redux';
import Upload from 'rc-upload';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import { Form, FieldTextInput, SecondaryButton, IconSpinner } from '../../components';
import { propTypes } from '../../util/types';
import { apiBaseUrl } from '../../util/api';
import { CiWarning } from 'react-icons/ci';
import { ImAttachment } from 'react-icons/im';
import { IoSendSharp } from 'react-icons/io5';

import css from './SendMessageForm.css';

const warningIcon = <CiWarning />;

const SendMessageFormComponent = props => {
  const [attachmentInProgress, setAttachmentInProgress] = useState(false);

  return (
    <FinalForm
      {...props}
      render={formRenderProps => {
        const {
          rootClassName,
          className,
          messagePlaceholder,
          handleSubmit,
          onAttachmentSubmit,
          inProgress,
          sendMessageError,
          invalid,
          form,
          formId,
          values,
        } = formRenderProps;

        const uploaderProps = {
          action: `${apiBaseUrl()}/api/upload-message-attachment`,
          name: 'attachment',
          data: { name: 'Attachment', desc: 'Message attachment file' },
          multiple: false,
          beforeUpload(file) {
            console.log('beforeUpload', file.name);
          },
          onStart: file => {
            setAttachmentInProgress(true);

            console.log('onStart', file.name);
          },
          onSuccess(result) {
            setAttachmentInProgress(false);

            console.log('onSuccess', result);

            const message = `<<<${result.id}|${result.name}>>>`;
            onAttachmentSubmit({ message }, form);
          },
          onProgress(step, file) {
            setAttachmentInProgress(true);
            console.log('onProgress', Math.round(step.percent), file.name);
          },
          onError(err) {
            console.log('onError', err);
          },
          capture: 'user',
        };

        const classes = classNames(rootClassName || css.root, className);
        const submitInProgress = inProgress;
        const submitDisabled = invalid || submitInProgress;
        return (
          <div>
            <Form className={classes} onSubmit={values => handleSubmit(values, form)}>
              <div className={css.errorContainer}>
                {sendMessageError ? (
                  <p className={css.error}>
                    <FormattedMessage id="SendMessageForm.sendFailed" />
                  </p>
                ) : null}
              </div>
              <div className={css.messageFieldContainer}>
                <FieldTextInput
                  inputRootClass={css.textarea}
                  type="textarea"
                  id={formId ? `${formId}.message` : 'message'}
                  name="message"
                  placeholder={messagePlaceholder}
                  // onFocus={this.handleFocus}
                  // onBlur={this.handleBlur}
                  icon={warningIcon}
                />
                <SecondaryButton
                  rootClassName={
                    values.message !== undefined ? css.submitButton : css.submitButtonHidden
                  }
                  inProgress={submitInProgress}
                  disabled={submitDisabled}
                  // onFocus={this.handleFocus}
                  // onBlur={this.handleBlur}
                >
                  <IoSendSharp className={css.sendIcon} />
                </SecondaryButton>
                <Upload
                  {...uploaderProps}
                  className={values.message === undefined ? css.upload : css.hidden}
                >
                  {attachmentInProgress ? (
                    <div className={css.uploading}>
                      <IconSpinner />
                    </div>
                  ) : (
                    <div className={css.showUpload}>
                      {/* <div className={css.maxAttachmentSize}>
                        <FormattedMessage id="SendMessageForm.maxAttachmentSize" />
                      </div> */}
                      <div title="Upload message attachment" className={css.uploadLink}>
                        <ImAttachment className={css.uploadIcon} />
                      </div>
                    </div>
                  )}
                </Upload>
              </div>
              {/* <div className={css.submitContainer}>
                {isFreelancer ? <div>{openCustomOfferModalButton}</div> : null}
              </div> */}
            </Form>
          </div>
        );
      }}
    />
  );
};

SendMessageFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  inProgress: false,
  messagePlaceholder: null,
  onFocus: () => null,
  onBlur: () => null,
  sendMessageError: null,
};

SendMessageFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  inProgress: bool,

  messagePlaceholder: string,
  onSubmit: func.isRequired,
  onFocus: func,
  onBlur: func,
  sendMessageError: propTypes.error,

  // from injectIntl
  intl: intlShape.isRequired,
};

const SendMessageForm = compose(injectIntl)(SendMessageFormComponent);

SendMessageForm.displayName = 'SendMessageForm';

export default SendMessageForm;
